<sc-error-page statusCode="404"
               i18n-statusCode
               title="The page does not exist."
               i18n-title
               [message]="message">
</sc-error-page>